import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ChatBot from "./ChatBot";
import WhatsAppFAB from "./WhatsAppFAB";
import AnnouncementPopup from "./AnnouncementPopup";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);
  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <ChatBot />
      <WhatsAppFAB />
      <AnnouncementPopup />
    </>
  );
}
